import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { FC, FormEvent, useState } from "react";
import { Link as RouterLink } from "react-router-dom";

import AppHeader from "../components/app-header.component";
import usePresentToast from "../hooks/present-toast.hook";
import { displayFontFamily } from "../theme/mtgTheme";

const NewDeckPage: FC = () => {
  const [deckName, setDeckName] = useState("");
  const { presentWarning } = usePresentToast();
  const trimmedDeckName = deckName.trim();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!trimmedDeckName) {
      return;
    }

    presentWarning("Deck saving isn't implemented yet.");
  };

  return (
    <Box sx={{ minHeight: "100vh", pb: 6 }}>
      <AppHeader />

      <Container maxWidth="xl" sx={{ py: { xs: 3, md: 4 } }}>
        <Stack spacing={3}>
          <Card>
            <CardContent
              component="form"
              onSubmit={handleSubmit}
              sx={{ p: { xs: 3, md: 4 } }}
            >
              <Stack spacing={3}>
                <Box>
                  <Typography variant="h3">New Deck</Typography>
                  <Typography
                    color="text.secondary"
                    sx={{
                      mt: 1.5,
                      maxWidth: 720,
                      fontFamily: displayFontFamily,
                      fontSize: "0.95rem",
                    }}
                  >
                    Start a new deck shell before persistence is connected.
                  </Typography>
                </Box>

                <Stack
                  direction={{ xs: "column", lg: "row" }}
                  spacing={1.5}
                  alignItems={{ lg: "flex-start" }}
                >
                  <TextField
                    label="Deck name"
                    value={deckName}
                    onChange={(event) => setDeckName(event.target.value)}
                    placeholder="Azorius Control"
                    autoFocus
                    fullWidth
                  />

                  <Stack direction="row" spacing={1}>
                    <Button
                      type="submit"
                      disabled={!trimmedDeckName}
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Save deck
                    </Button>
                    <Button
                      component={RouterLink}
                      to="/decks"
                      variant="outlined"
                      sx={{ whiteSpace: "nowrap" }}
                    >
                      Back
                    </Button>
                  </Stack>
                </Stack>

                <Alert severity="info">
                  Deck saving is not implemented yet. This page currently
                  captures the frontend flow only.
                </Alert>
              </Stack>
            </CardContent>
          </Card>
        </Stack>
      </Container>
    </Box>
  );
};

export default NewDeckPage;
